(function () {
  const overlay = document.getElementById('select-options-overlay');
  if (!overlay) return;

  const modal = document.getElementById('select-options-modal');
  const closeBtn = document.getElementById('select-options-close');
  const cancelBtn = document.getElementById('select-options-cancel');
  const applyBtn = document.getElementById('select-options-apply');
  const trigger = document.getElementById('select-options-trigger');

  // Load variant data
  const dataEl = document.getElementById('select-options-variants-data');
  let productData = { variants: [], options: [] };
  if (dataEl) {
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Failed to parse variant data', e);
    }
  }

  // Track selections per option index
  let selections = {};

  function getSelectedValues() {
    var values = {};
    for (var key in selections) {
      values[key] = selections[key].value;
    }
    return values;
  }

  // Cascading filter: option 0 (Size) always shows all, option 1 (Dimensions)
  // filters by option 0 only, option 2 (Thickness) filters by options 0+1.
  function getAvailableValues(optionIndex) {
    var currentSelections = getSelectedValues();
    var available = new Set();

    // Option 0 (first option, e.g. Size) — always show all values
    if (parseInt(optionIndex) === 0) {
      productData.variants.forEach(function (variant) {
        if (!variant.available) return;
        available.add(variant.options[0]);
      });
      return available;
    }

    productData.variants.forEach(function (variant) {
      if (!variant.available) return;

      // Only check options BEFORE this one (upstream), not after
      var matches = true;
      for (var i = 0; i < parseInt(optionIndex); i++) {
        if (currentSelections[String(i)] && variant.options[i] !== currentSelections[String(i)]) {
          matches = false;
          break;
        }
      }

      if (matches) {
        available.add(variant.options[parseInt(optionIndex)]);
      }
    });

    return available;
  }

  // Update pill visibility based on current selections — hide unavailable, show available
  function updatePillAvailability() {
    var groups = modal.querySelectorAll('.select-options-modal__pills');

    groups.forEach(function (group) {
      var optionIndex = group.dataset.optionIndex;
      var available = getAvailableValues(parseInt(optionIndex));

      var needsReselect = false;

      group.querySelectorAll('.select-options-modal__pill').forEach(function (pill) {
        var value = pill.dataset.value;
        if (available.has(value)) {
          pill.style.display = '';
          pill.classList.remove('select-options-modal__pill--unavailable');
          pill.removeAttribute('aria-disabled');
        } else {
          pill.style.display = 'none';
          pill.classList.add('select-options-modal__pill--unavailable');
          pill.setAttribute('aria-disabled', 'true');

          // If this hidden pill was selected, we need to reselect
          if (pill.classList.contains('select-options-modal__pill--selected')) {
            pill.classList.remove('select-options-modal__pill--selected');
            delete selections[optionIndex];
            needsReselect = true;
          }
        }
      });

      // Auto-select the first visible pill if current selection was hidden
      if (needsReselect) {
        var firstVisible = group.querySelector(
          '.select-options-modal__pill:not(.select-options-modal__pill--unavailable)'
        );
        if (firstVisible) {
          firstVisible.classList.add('select-options-modal__pill--selected');
          selections[optionIndex] = {
            value: firstVisible.dataset.value,
            optionValueId: firstVisible.dataset.optionValueId,
            optionPosition: firstVisible.dataset.optionPosition,
          };
        }
      }
    });
  }

  function initSelections() {
    selections = {};
    modal.querySelectorAll('.select-options-modal__pills').forEach(function (group) {
      var index = group.dataset.optionIndex;
      var selectedPill = group.querySelector('.select-options-modal__pill--selected');
      if (selectedPill) {
        selections[index] = {
          value: selectedPill.dataset.value,
          optionValueId: selectedPill.dataset.optionValueId,
          optionPosition: selectedPill.dataset.optionPosition,
        };
      }
    });
    updatePillAvailability();
  }

  function openModal() {
    // Sync selections from the actual variant picker before opening
    syncFromVariantPicker();
    overlay.style.display = 'flex';
    overlay.classList.remove('closing');
    document.body.style.overflow = 'hidden';
  }

  function syncFromVariantPicker() {
    var variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) {
      initSelections();
      return;
    }

    selections = {};
    var groups = modal.querySelectorAll('.select-options-modal__pills');

    groups.forEach(function (group) {
      var optionIndex = group.dataset.optionIndex;

      // Get current value from variant picker
      var fieldset = variantPicker.querySelector(
        '[data-fieldset-index="' + optionIndex + '"]'
      );
      var currentValue = null;

      if (fieldset) {
        var checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          currentValue = checkedRadio.value;
        }
      } else {
        var selects = variantPicker.querySelectorAll('.variant-option__select');
        if (selects[optionIndex]) {
          currentValue = selects[optionIndex].value;
        }
      }

      // Update modal pills to match
      group.querySelectorAll('.select-options-modal__pill').forEach(function (pill) {
        pill.classList.remove('select-options-modal__pill--selected');
      });

      if (currentValue) {
        var matchingPill = group.querySelector(
          '.select-options-modal__pill[data-value="' + CSS.escape(currentValue) + '"]'
        );
        if (matchingPill) {
          matchingPill.classList.add('select-options-modal__pill--selected');
          selections[optionIndex] = {
            value: matchingPill.dataset.value,
            optionValueId: matchingPill.dataset.optionValueId,
            optionPosition: matchingPill.dataset.optionPosition,
          };
        }
      }
    });

    updatePillAvailability();
  }

  function closeModal() {
    overlay.classList.add('closing');
    setTimeout(function () {
      overlay.style.display = 'none';
      overlay.classList.remove('closing');
      document.body.style.overflow = '';
    }, 250);
  }

  // Pill click handler
  modal.addEventListener('click', function (e) {
    var pill = e.target.closest('.select-options-modal__pill');
    if (!pill || pill.classList.contains('select-options-modal__pill--unavailable')) return;

    var group = pill.closest('.select-options-modal__pills');
    var optionIndex = group.dataset.optionIndex;

    // Deselect all pills in this group
    group.querySelectorAll('.select-options-modal__pill').forEach(function (p) {
      p.classList.remove('select-options-modal__pill--selected');
    });

    // Select clicked pill
    pill.classList.add('select-options-modal__pill--selected');

    selections[optionIndex] = {
      value: pill.dataset.value,
      optionValueId: pill.dataset.optionValueId,
      optionPosition: pill.dataset.optionPosition,
    };

    // Update availability of other option groups
    updatePillAvailability();
  });

  // Show the chosen values on the trigger button (right side)
  function updateTriggerLabel() {
    var el = document.getElementById('select-options-trigger-selected');
    if (!el) return;
    var parts = [];
    Object.keys(selections)
      .sort(function (a, b) { return parseInt(a) - parseInt(b); })
      .forEach(function (i) {
        if (selections[i] && selections[i].value) parts.push(selections[i].value);
      });
    el.textContent = parts.join(' / ');
  }

  // Apply selections back to the actual variant picker
  function applySelections() {
    var variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;

    Object.keys(selections).forEach(function (optionIndex) {
      var sel = selections[optionIndex];
      var value = sel.value;

      var fieldset = variantPicker.querySelector(
        '[data-fieldset-index="' + optionIndex + '"]'
      );

      if (fieldset) {
        var radio = fieldset.querySelector(
          'input[type="radio"][value="' + CSS.escape(value) + '"]'
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
          radio.click();
        }
      } else {
        var selects = variantPicker.querySelectorAll('.variant-option__select');
        if (selects[optionIndex]) {
          selects[optionIndex].value = value;
          selects[optionIndex].dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  // Event listeners
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (cancelBtn) cancelBtn.addEventListener('click', closeModal);

  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      applySelections();
      updateTriggerLabel();
      closeModal();
    });
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display === 'flex') {
      closeModal();
    }
  });

  if (trigger) {
    trigger.addEventListener('click', openModal);
  }

  window.openSelectOptionsModal = openModal;
})();
